import React from "react";
import CEOimage from "../../assets/Franco.jpg";
import Empty from "../../assets/Empty.png";

const TeamSection = () => {
  const teamMembers = [
    {
      id: 2,
      name: "Franco Stander",
      role: "Project Manager",
      image: CEOimage,
      num: "01",
    },
    {
      id: 3,
      name: "Rico Stander",
      role: "IT Support",
      image: Empty,
      num: "02",
    },
  ];

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

    .team-root { font-family: 'DM Sans', sans-serif; background: #fafaf8; border-bottom: 1px solid #e8e8e4; }

    .team-header { padding: 7rem 7vw 5rem; display: flex; align-items: flex-end; justify-content: space-between; gap: 3rem; flex-wrap: wrap; border-bottom: 1px solid #e8e8e4; }

    .team-eyebrow { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.5rem; }
    .team-eyebrow-line { width: 28px; height: 1px; background: #E78730; flex-shrink: 0; }
    .team-eyebrow-text { font-size: 0.68rem; letter-spacing: 0.26em; text-transform: uppercase; color: #E78730; font-weight: 500; }

    .team-h2 { font-family: 'DM Serif Display', serif; font-size: clamp(2rem, 4vw, 3rem); line-height: 1.05; color: #1a1a1a; margin: 0; max-width: 18ch; }
    .team-h2 em { color: #E78730; font-style: italic; }

    .team-desc { font-size: 0.93rem; color: #888; line-height: 1.8; font-weight: 300; max-width: 44ch; }

    .team-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-left: 1px solid #e8e8e4;
  max-width: 760px;
  margin: 0 auto;   /* 🔥 THIS centers it */
}
    .team-card { border-right: 1px solid #e8e8e4; overflow: hidden; position: relative; }

 .team-img-wrap {
  height: 320px;
  position: relative;
  background: #ede9e3;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
}

.team-img {
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;

  object-fit: contain;   /* 🔥 prevents cropping */
  object-position: center;

  filter: grayscale(15%);
  transition: filter 0.5s ease, transform 0.5s ease;
  display: block;
}

.team-card:hover .team-img {
  filter: grayscale(0%);
  transform: scale(1.03);
}
    .team-num { position: absolute; top: 1.5rem; left: 1.75rem; font-family: 'DM Serif Display', serif; font-size: 0.85rem; color: rgba(255,255,255,0.5); letter-spacing: 0.1em; z-index: 1; }

    .team-info { padding: 2rem 2.5rem; border-top: 1px solid #e8e8e4; display: flex; align-items: center; justify-content: space-between; gap: 1rem; }

    .team-name { font-family: 'DM Serif Display', serif; font-size: 1.5rem; color: #1a1a1a; margin-bottom: 0.25rem; }
    .team-role { font-size: 0.68rem; letter-spacing: 0.18em; text-transform: uppercase; color: #E78730; font-weight: 500; }
    .team-info-line { width: 24px; height: 1px; background: #e8e8e4; flex-shrink: 0; }

    @media (max-width: 640px) {
  .team-grid {
    grid-template-columns: 1fr; /* single column on mobile */
    max-width: 100%;            /* remove fixed max-width */
    border-left: none;          /* remove left border */
  }

  .team-card {
    display: flex;
    flex-direction: column;     /* stack info above image */
    align-items: center;
    border-right: none;
    border-bottom: 1px solid #e8e8e4;
    padding-bottom: 1.5rem;
  }

  .team-info {
    order: -1;                  /* move info above image */
    padding: 0 0 1rem 0;        /* spacing below info */
    border-top: none;
    width: 100%;
    text-align: center;         /* center text */
    justify-content: center;
  }

  .team-img-wrap {
    height: 220px;              /* adjust image height for mobile */
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
  }

  .team-name { font-size: 1.25rem; }
  .team-role { font-size: 0.75rem; }
}
}
  `;

  return (
    <>
      <style>{styles}</style>
      <section className="team-root">
        <div className="team-header">
          <div>
            <div className="team-eyebrow">
              <span className="team-eyebrow-line" />
              <span className="team-eyebrow-text">Our Leadership Team</span>
            </div>
            <h2 className="team-h2">
              Expert Professionals <em>Driving Success</em>
            </h2>
          </div>
          <p className="team-desc">
            Our team comprises highly qualified engineers and specialists with
            proven track records in delivering complex projects across diverse
            sectors.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-img-wrap">
                <span className="team-num">{member.num}</span>
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <div>
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                </div>
                <div className="team-info-line" />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default TeamSection;
